import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, List } from '@mui/material';

import { MenuCategoryGroup } from 'components/menu/MenuCategoryGroup';
import { ICategoryGroup } from 'components/menu/model/Menu';
import { RecentOrdersList } from 'components/recentOrders/RecentOrdersList';
import { IOrderReadResourceV18 } from 'components/order/model/Order';

const PREFIX = 'MenuCategoryGroupsList';

const classes = {
    categoryGroups: `${PREFIX}categoryGroups`
};

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    flex: 1,
    width: '100%',
    paddingBottom: theme.spacing(6),
    paddingTop: theme.spacing(1),
    [`& .${classes.categoryGroups}`]: {
        flex: 1,
        padding: theme.spacing(0, 1.5, 7, 1.5)
    }
}));

interface IMenuCategoryGroupsListProps {
    onClick: (categoryGroup: ICategoryGroup) => void;
    recentOrders?: IOrderReadResourceV18[];
    categoryGroups?: ICategoryGroup[];
}

export const MenuCategoryGroupsList: React.FC<React.PropsWithChildren<IMenuCategoryGroupsListProps>> = ({
    onClick,
    recentOrders,
    categoryGroups
}) => {
    const renderCategoryGroupItem = React.useCallback(
        (item: ICategoryGroup) => <MenuCategoryGroup onClick={onClick} categoryGroup={item} key={item.id} />,
        [onClick]
    );

    return (
        <StyledBox>
            <List className={classes.categoryGroups}>
                {!!recentOrders && <RecentOrdersList orders={recentOrders} />}
                {!!categoryGroups && categoryGroups.map(renderCategoryGroupItem)}
            </List>
        </StyledBox>
    );
};
